export const valueToOption = (value) => {
  return value && { value, label: value };
};

export const arrayToOptions = (array) => {
  return array.map(valueToOption);
};
